import {
    AfterViewInit,
    ApplicationRef,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostListener,
    OnDestroy,
    OnInit,
    QueryList,
    ViewChild,
    ViewChildren,
    ViewEncapsulation,
} from "@angular/core";

import { fuseAnimations } from "@fuse/animations";
import { StorageService } from "app/main/module/common/service/storage.service";
import { Load } from "../load";
import { LoadService } from "../load.service";
import { LoadListColumns } from "./columns";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import {
    customLoadType,
    customProgram,
    getLoadColor,
    getLoadStatus,
    getSingleLoadColor,
} from "./loadutils";
import { ApiService } from "app/main/module/common/service/api.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import { set } from "lodash";

const timeZone = require("moment-timezone");

@Component({
    selector: "load-table",
    templateUrl: "load-list.component.html",
    styleUrls: ["load.component.scss"],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None,
})
export class LoadlistComponent implements OnDestroy, AfterViewInit, OnInit {
    allData: Array<any> = [];
    errorMessage: any;
    isLoginFailed: boolean;
    columns: any[] = [];
    displayedColumns: string[] = [];

    loadData: Load[] = [];
    dataSource = new MatTableDataSource<any>(this.loadData);
    dataSourceFilters = new MatTableDataSource(this.loadData);
    dataSourceWithPageSize = new MatTableDataSource(this.loadData);
    prev: number = 1;
    next: number = 1;
    page: number;
    count: number;
    totalPage: boolean;
    @ViewChild("table") table: ElementRef;
    isLoading: boolean = false;
    isNextPressed: boolean = false;
    searchText: any;
    isEnterPressed: boolean;
    translationKeys = [
        "Loads.Sr",
        "Loads.Sterilizer",
        "Loads.Type",
        "Loads.Program",
        "Loads.CycleNo",
        "Loads.Barcode",
        "Loads.BD",
        "Loads.BI",
        "Loads.EI",
        "Loads.User",
        "Loads.DateTime",
        "Loads.Status",
        "Loads.MoreDetails",
        "Loads.ViewImage",
        "Loads.ViewReport",
    ];
    hasMoreData: boolean = true;
    PAGE_SIZE: number = 10;
    private observer: MutationObserver | null = null;
    overflowFlags: boolean[] = [];
    @ViewChildren("cellContent") cellContents!: QueryList<ElementRef>;
    searchDisabled: boolean = false;
    isDataLoaded: boolean = true;

    constructor(
        public snackBar: MatSnackBar,
        private userSevice: StorageService,
        private apiService: ApiService,
        public loadListService: LoadService,
        private changeDetectorRefs: ChangeDetectorRef,
        private route: ActivatedRoute,
        private router: Router,
        private translate: TranslateService,
        private el: ElementRef,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.loadData = [];
        this.dataSource.data = [];
        this.isLoading = true;
        this.prev = 0;
        this.next = 1;
        this.page = 0;
        this.count = 1;
        const lab_id = this.userSevice.getCookie("lab_id");
        const keys = [
            "Common.Sr",
            "Common.Sterilizer",
            "Common.Type",
            "Common.Program",
            "Common.CycleNo",
            "Common.Barcode",
            "Common.BD",
            "Common.BI",
            "Common.EI",
            "Common.User",
            "Common.DateTime",
            "Common.Status",
            "Common.Details",
            "Loads.AIImage",
            "Loads.ViewReport",
        ];
        this.translate.onLangChange.subscribe(() => {
            this.translate.get(keys).subscribe((translations) => {
                this.columns = this.getColumn(translations);
                this.displayedColumns = this.columns.map((c) => c.columnDef);
            });
        });

        this.translate.get(keys).subscribe((translations) => {
            this.columns = this.getColumn(translations);
            this.displayedColumns = this.columns.map((c) => c.columnDef);
        });

        if (lab_id) {
            this.getAllData(1);
        } else {
            this.logout();
        }
    }

    getAllData(page) {
        this.loadListService.getAllLoadDataByLabId(page).subscribe(
            (a) => {
                Object.entries(a).find(([key, value]) => {
                    if (key == "message" && value == "No data Found") {
                        this.totalPage = true;
                        this.isLoading = false;
                        this.isDataLoaded = true;
                        this.searchDisabled = false;
                        this.openSnackBar(
                            this.translateSentence("Common.noDataFound"),
                            this.translateSentence("Common.ok"),
                        );
                    }
                    if (key == "data") {
                        this.allData = value;
                        this.isDataLoaded = true;
                        this.searchDisabled = false;
                        this.hasMoreData =
                            this.allData.length === this.PAGE_SIZE;
                        if (!this.hasMoreData && this.isNextPressed) {
                            this.openSnackBar(
                                this.translateSentence(
                                    "Common.noFurtherDataAvailable",
                                ),
                                this.translateSentence("Common.ok"),
                            );
                        }

                        this.allData.forEach((element) => {
                            this.isLoading = false;
                            this.changeDetectorRefs.markForCheck();
                            this.changeDetectorRefs.detectChanges();
                            this.loadData.push({
                                machine_name: element.machine_name,
                                _id: "",
                                load_id: element.load_id,
                                bd_barcode: element.bd_barcode,
                                bi_barcode: element.bi_barcode,
                                ei_barcode: element.ei_barcode,
                                load_status: element.load_status,
                                statusBd: element.bd_status,
                                statusBi: element.bi_status,
                                statusEi: element.ei_status,
                                type: element.load_type,
                                version: 0,
                                cycle_number: element.cycle_number,
                                load_number: element.load_number,
                                loadIdStr: "",
                                machineIdStr: "",
                                aiLink: "",
                                cassetteIds: [],
                                machineReport: "",
                                machineReportText: "",
                                pendingEis: [],
                                program: element.load_program,
                                startTimeNum: "",
                                started_by: element.started_by,
                                updated_by: element.updated_by,
                                time: "",
                                date: "",
                                machineReportUrl: element.ma,
                                image_url: element.image_url,
                                load_report_url: element.load_report_url,
                                started_timestamp: element.started_timestamp,
                                updated_timestamp: element.updated_timestamp,
                            });
                        });
                    } else {
                        // // // console.log(e);
                    }
                });

                this.dataSource.data = this.loadData;
            },

            (err) => {
                this.errorMessage = err.error.message;
                // console.log(e);
                if (err.status == 401) {
                    // // console.log(");,
                    alert(this.translateSentence("Common.InvalidToken"));
                    this.logout();
                }
                this.logout();
                this.isLoginFailed = true;
            },
        );
    }

    logout(): void {
        localStorage.clear();
        this.userSevice.clearCookie();
        // this.globals.cassetteConfig = null;
        this.router.navigate(["/login"]);
        // location.reload();
    }

    getColumn(translations: { [key: string]: string }): any[] {
        return [
            {
                columnDef: "Sr",
                header: translations["Common.Sr"],
                cell: (element: Load, index: number) =>
                    `${this.page * 10 + index + 1}`,
            },
            {
                columnDef: "Sterilizer",
                header: translations["Common.Sterilizer"],
                cell: (element: Load) => `${element.machine_name}`,
            },
            {
                columnDef: "Type",
                header: translations["Common.Type"],
                cell: (element: Load) => customLoadType(element.type),
            },
            {
                columnDef: "Program",
                header: translations["Common.Program"],
                cell: (element: Load) =>
                    customProgram(element.type, element.program),
            },
            {
                columnDef: "Cycle No",
                header: translations["Common.CycleNo"],
                cell: (element: Load) => `${element.cycle_number}`,
            },
            {
                columnDef: "Barcode",
                header: translations["Common.Barcode"],
                cell: (element: Load) => `${element.load_id}`,
            },
            {
                columnDef: "BD",
                header: translations["Common.BD"],
                cell: (element: Load) => `${element.bd_barcode || "-"}`,
                textColor: (element: Load, index: number) =>
                    `${getSingleLoadColor(element.statusBd)}`,
            },
            {
                columnDef: "BI",
                header: translations["Common.BI"],
                cell: (element: Load) => `${element.bi_barcode || "-"}`,
                textColor: (element: Load, index: number) =>
                    `${getSingleLoadColor(element.statusBi)}`,
            },
            {
                columnDef: "EI",
                header: translations["Common.EI"],
                cell: (element: Load) => `${element.ei_barcode || ""}`,
                textColor: (element: Load, index: number) =>
                    `${getSingleLoadColor(element.statusEi)}`,
            },
            {
                columnDef: "User",
                header: translations["Common.User"],
                cell: (element: Load) => `${element.started_by.name}`,
            },
            {
                columnDef: "Date",
                header: translations["Common.DateTime"],
                cell: (element: Load) =>
                    this.changeDate(element.updated_timestamp),
            },
            {
                columnDef: "Status",
                header: translations["Common.Status"],
                cell: (element: Load) => {
                    const status = getLoadStatus(element);
                    const translationKey = `Status.${status}`;
                    return this.translateSentence(translationKey);
                },
                textColor: (element: Load, index: number) =>
                    `${getLoadColor(element)}`,
            },
            {
                columnDef: "details",
                header: translations["Common.Details"],
                cell: (element: Load) => `${element.load_number}`,
            },
            {
                columnDef: "AI Image",
                header: translations["Loads.AIImage"],
                cell: (element: Load) => `${element.image_url || ""}`,
            },
            {
                columnDef: "view",
                header: translations["Loads.ViewReport"],
                cell: (element: Load) =>
                    `${
                        element.machineReportUrl ||
                        element.load_report_url ||
                        ""
                    }`,
            },
        ];
    }

    onClickSearch(searchText) {
        if (!searchText || !searchText.trim()) {
            this.openSnackBar(
                this.translateSentence("Common.noSearchValueAvailable"),
                this.translateSentence("Common.ok"),
            );
        } else {
            this.searchText = searchText.replace(/[^a-zA-Z0-9 ]/g, "").trim();
            this.loadData = [];
            this.dataSource.data = [];
            this.totalPage = true;
            this.isLoading = true;
            this.searchDisabled = true;
            this.isDataLoaded = false;
            this.loadListService.searchLoad(this.searchText).subscribe(
                (a) => {
                    // // console.log(a);
                    Object.entries(a).find(([key, value]) => {
                        if (key == "data") {
                            this.allData = value;
                            this.allData.forEach((element) => {
                                // // console.log(d);
                                this.isLoading = false;
                                this.searchDisabled = false;
                                this.isDataLoaded = true;

                                this.loadData.push({
                                    machine_name: element.machine_name,
                                    _id: "",
                                    load_id: element.load_id,
                                    bd_barcode: element.bd_barcode,
                                    bi_barcode: element.bi_barcode,
                                    ei_barcode: element.ei_barcode,
                                    load_status: element.load_status,
                                    statusBd: element.bd_status,
                                    statusBi: element.bi_status,
                                    statusEi: element.ei_status,
                                    type: element.load_type,
                                    version: 0,
                                    cycle_number: element.cycle_number,
                                    load_number: element.load_number,
                                    loadIdStr: "",
                                    machineIdStr: "",
                                    aiLink: "",
                                    cassetteIds: [],
                                    machineReport: "",
                                    machineReportText: "",
                                    pendingEis: [],
                                    program: "",
                                    startTimeNum: "",
                                    started_by: element.started_by,
                                    updated_by: element.updated_by,
                                    time: "",
                                    date: "",
                                    machineReportUrl: element.ma,
                                    image_url: element.image_url,
                                    load_report_url: element.load_report_url,
                                    started_timestamp:
                                        element.started_timestamp,
                                    updated_timestamp:
                                        element.updated_timestamp,
                                });
                            });
                            const msg = "Data Found";
                            this.openSnackBar(msg, "OK");
                        } else if (key == "status" && value == "failed") {
                            // else {
                            // // console.log(e);
                            this.isLoading = false;
                            this.searchDisabled = false;
                            this.isDataLoaded = true;
                            const msg =
                                this.translateSentence("Common.noDataFound");
                            this.openSnackBar(
                                msg,
                                this.translateSentence("Common.ok"),
                            );
                            // window.location.reload();
                        }
                    });
                    //  // // console.log(a);

                    this.dataSource.data = this.loadData;
                },

                (err) => {
                    this.errorMessage = err.error.message;
                    this.searchDisabled = false;
                    this.isDataLoaded = true;
                    // // console.log(e);
                    this.isLoginFailed = true;
                },
            );
        }
    }

    openSnackBar(message: string, action: string): void {
        // this.isLoading = true;
        // this.hasFirstDataShown = true;
        this.snackBar.open(message, action, {
            duration: 1000,
        });
    }

    refreshSearch(event) {
        if (event.code === "Backspace" && this.searchText.length === 1) {
            this.searchText = "";
            this.totalPage = false;
            this.searchDisabled = true;
            this.isDataLoaded = true;
            this.ngOnInit();
        }
    }

    changeDate(date): any {
        // // // console.log(e);

        var timestamp = parseInt(date);

        return (date = this.apiService.getDateStringMomentByTz(timestamp));
    }

    changeTime(time): any {
        var timestamp = parseInt(time);

        return (time =
            this.apiService.getDateStringMomentByTzOnlyTime(timestamp));
    }

    clearInputSearch() {
        this.searchText = "";
        this.totalPage = false;
        this.searchDisabled = true;
        this.isDataLoaded = true;
        this.ngOnInit();
    }

    changeTimestampToDate(timestamp: string): string {
        if (timestamp) {
            // new Date('03/17/2021');
            return timeZone(timestamp)
                .tz(this.userSevice.getCookie("defaultTz"))
                .format("DD/MM/YYYY");
            // return moment(timestamp).format("DD/MM/YYYY");
        }
        return "";
    }

    viewLOad(barcode) {
        this.router.navigate(["/loaddetail"], {
            queryParams: { load_barcode: barcode },
        });
    }

    openDetail(row) {
        // // console.log(w);
        // window.open(row.fileUrl, "_blank");
        window.open(row, "_blank");
    }

    onNextPress() {
        this.isLoading = true;
        this.isNextPressed = true;
        this.count = this.count + 1;
        this.next = this.prev + 1;
        this.prev = this.next - 1;
        this.next++;
        this.prev++;
        this.getAllData(this.next);
    }

    onPrevPress() {
        this.count = this.count - 1;
        this.prev = this.next - 1;
        this.prev--;
        this.next--;
        this.getAllData(this.prev);
        // // console.log(t);
    }

    @HostListener("document:keypress", ["$event"])
    handleKeyboardEvent(event: KeyboardEvent) {
        this.handleEnterSearch(event);
    }

    handleEnterSearch(event: KeyboardEvent) {
        if (
            event.key.includes("Enter") &&
            event.code.includes("Enter") &&
            document.activeElement.id.includes("search")
        ) {
            this.isEnterPressed = true;
            if (this.searchText && this.searchText.length > 0) {
                this.onClickSearch(this.searchText);
            }
        } else {
            this.isEnterPressed = false;
        }
    }

    ngAfterViewInit(): void {
        const table: HTMLElement | null =
            this.el.nativeElement.querySelector("mat-table");
        if (!table) return;

        this.observer = new MutationObserver((mutations) => {
            if (!this.isNextPressed) return;

            const rows = table.querySelectorAll(".mat-row");
            if (rows.length > 0) {
                const last = rows[rows.length - 1] as HTMLElement;
                last.scrollIntoView({ behavior: "smooth", block: "end" });
                this.isNextPressed = false;
            }
        });

        this.observer.observe(table, { childList: true, subtree: true });
        this.updateOverflowFlags();

        this.cellContents.changes.subscribe(() => this.updateOverflowFlags());
    }

    ngOnDestroy(): void {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    private updateOverflowFlags(): void {
        this.overflowFlags = this.cellContents.map((el) =>
            this.isTextOverflowing(el.nativeElement),
        );
        this.cdr.detectChanges();
    }

    isTextOverflowing(element: HTMLElement): boolean {
        return element.scrollWidth > element.clientWidth;
    }

    translateSentence(key: string, params?: any): string {
        return this.translate.instant(key, params);
    }
}
